/**
 * Used to determine user intention of signing in or signing up during the identification.
 */
export const SigningIntentionType = {
    signIn: 'sign_in',
    signUp: 'sign_up'
};
